import { APP_INITIALIZER, inject } from '@angular/core';
import { ConfigStateService, RoutesService } from '@abp/ng.core';
import { VIAGEM_BASE_ROUTES } from './viagem-base.route';
import { addRoutesWhenAnyFeatureEnabled } from '../../shared/routes/feature-routes.util';

export const VIAGEM_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    multi: true,
    useFactory: configureRoutes,
  },
];

function configureRoutes() {
  const routesService = inject(RoutesService);
  const configState = inject(ConfigStateService);

  return () => {
    addRoutesWhenAnyFeatureEnabled(
      routesService,
      configState,
      ['cargo_fleet.GerenciamentoDeViagem'],
      [...VIAGEM_BASE_ROUTES],
    );
  };
}
